type Props = {
  updatedAt: string | null;
  multiple?: boolean;
};

const formatter = new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" });

export const ModifiedCell = ({ updatedAt, multiple }: Props) => {
  if (multiple) {
    return <span className="text-xs text-primary font-medium">Multiple</span>;
  }
  if (!updatedAt) {
    return <span className="text-xs text-primary font-medium">-</span>;
  }
  return (
    <span className="text-xs text-primary font-medium whitespace-nowrap">{formatter.format(new Date(updatedAt))}</span>
  );
};
